import React from 'react';
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBDataTable } from 'mdbreact';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import * as misConstantes from '../../../js/constantes';
import axios from "axios";


class CambiarProveedor extends React.Component {
	constructor(props) {
	    super(props);

		
 		var columnas = [ 
								{ field: "nombre", label: "Nombre", attributes: {'width':'80%'} },
								{ field:"botones", label: "", sort: 'asc', width :  "20%" , attributes: { 'width': '20%', 'align': 'center' } }
 
 						];
	    this.state = {  
	    						datos: {columns: columnas, rows:[]}, 
								columnas: columnas, mostrarSeleccionarProveedor: false
						};
	}
	render(){
		 return <>
					<a href="" class="dropdown-item" onClick = {this.abrirCambiarProveedor.bind(this)}>Cambiar entidad</a>
					
					<Modal show={ this.state.mostrarSeleccionarProveedor } onHide={  this.handleCloseSeleccionarProveedor.bind(this)  }>
						 <Modal.Header closeButton>
							 <Modal.Title>Seleccionar proveedor</Modal.Title>
						 </Modal.Header>
						 <Modal.Body>
								<MDBDataTable striped bordered  small data={ this.state.datos } hover entriesOptions={[5, 10, 15, 25]} entries={15} pagesAmount={4} condensed={true}/>
						 </Modal.Body>
						 <Modal.Footer>
							<Button variant="secondary" onClick = { this.handleCloseSeleccionarProveedor.bind( this ) }>Cerrar</Button>
						 </Modal.Footer>
					 </Modal>
				</>
	}
	handleCloseSeleccionarProveedor(event){
		this.setState({ mostrarSeleccionarProveedor: false });
	}
	abrirCambiarProveedor( event ){
		event.preventDefault();
		this.setState({ mostrarSeleccionarProveedor: true });
		
		
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var info = { "codigo": codigo};
		axios.post( misConstantes.URL_CONSULTA + '/ServletProveedores', info, {params: info}).then(function (response) {
			var proveedores = response.data;
			var columns = this.state.columnas;
			var rows = [];
			for( var i = 0; i < proveedores.length; i++ ){
				
				const identificador = proveedores[i].id + "";
				var row = {
							nombre:  proveedores[i].id + ". " + proveedores[i].nit + ". " +  proveedores[i].nombre,

							botones: <div style = {{width: "100%", textAlign: "center" }}>
											<a href = '' onClick = {  (event) => this.handleSeleccionarProveedor(event, identificador + "" ) } ><i class="fas fa-hand-pointer"></i></a>
									</div>
						}
				rows.push(row);
			}

			var datos = {columns: columns, rows: rows}
			this.setState({datos: datos});

			
		}.bind(this)).catch(function (error) {
		});
		
	}
	handleSeleccionarProveedor( event, identificador ){
		event.preventDefault();
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );		
		var info = { "codigo": codigo, "idProveedor":identificador };
		
//		alert( JSON.stringify(info) );

		axios.post( misConstantes.URL_CONSULTA + '/ServletCambiarProveedor', info, {params: info}).then(function (response) {
			var respuesta = response.data;
//			alert(  JSON.stringify( respuesta )  );
			window.location.href = "/cotizaciones";
		}.bind(this)).catch(function (error) {
		});
		
	}
		
}
export default CambiarProveedor;